import React, { createContext, useContext, useState, useCallback, useRef } from "react";
import api from "../../services/api";
import { toast } from "react-toastify";
import ModalSelecionarFilial from "./index";

interface FilialOption {
    valor: string;
    label: string;
}

interface FilialLoteContextType {
    abrirModalLote: (entidade: string, ids: (string | number)[], filiais: FilialOption[], onSucesso?: () => void) => void;
}

const FilialLoteContext = createContext<FilialLoteContextType>({
    abrirModalLote: () => {},
});

export function useFilialLote() {
    return useContext(FilialLoteContext);
}

export function FilialLoteProvider({ children }: { children: React.ReactNode }) {
    const [modalAberto, setModalAberto] = useState(false);
    const [filiais, setFiliais] = useState<FilialOption[]>([]);
    const [qtdRegistros, setQtdRegistros] = useState(0);
    const entidadeRef = useRef('');
    const idsRef = useRef<(string | number)[]>([]);
    const onSucessoRef = useRef<(() => void) | undefined>();

    const abrirModalLote = useCallback((entidade: string, ids: (string | number)[], filiaisOpt: FilialOption[], onSucesso?: () => void) => {
        if (!ids || ids.length === 0) {
            toast.warning('Selecione ao menos um registro.');
            return;
        }
        entidadeRef.current = entidade;
        idsRef.current = ids;
        onSucessoRef.current = onSucesso;
        setFiliais(filiaisOpt);
        setQtdRegistros(ids.length);
        setModalAberto(true);
    }, []);

    const handleConfirm = useCallback(async (idFilial: string) => {
        setModalAberto(false);
        try {
            const response = await api.post('/Filial/AssociarEmLote', {
                entidade: entidadeRef.current,
                idFilial,
                ids: idsRef.current.map(id => String(id)),
            });
            const filialNome = filiais.find(f => f.valor === idFilial)?.label || '';
            toast.success(`${response.data.registrosAfetados} registro(s) associado(s) à unidade "${filialNome}".`);
            onSucessoRef.current?.();
        } catch (error: any) {
            const msg = error.response?.data?.Mensagem || 'Erro ao associar unidade em lote.';
            toast.error(msg);
        }
    }, [filiais]);

    const handleCancel = useCallback(() => {
        setModalAberto(false);
    }, []);

    return (
        <FilialLoteContext.Provider value={{ abrirModalLote }}>
            {children}
            <ModalSelecionarFilial
                show={modalAberto}
                filiais={filiais}
                qtdRegistros={qtdRegistros}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
            />
        </FilialLoteContext.Provider>
    );
}
